"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";
import * as React from "react";

import { cn } from "@/utils/lib";
import { resolveClassName } from "@/utils/resolve-class-name";

const Switch = ({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) => (
  <SwitchPrimitive.Root
    className={(state) =>
      cn(
        `
          peer
          inline-flex h-5
          w-9
          shrink-0
          cursor-pointer
          items-center
          rounded-full border-2 border-transparent shadow-xs transition-colors hover:bg-muted-foreground focus-visible:ring-2
          focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:outline-hidden
          data-checked:bg-primary data-disabled:cursor-not-allowed
          data-disabled:opacity-50
          data-unchecked:bg-muted data-unchecked:hover:bg-muted-foreground
        `,
        resolveClassName(className, state),
      )
    }
    {...props}
  >
    <SwitchPrimitive.Thumb
      className="
        pointer-events-none block size-4 rounded-full bg-background shadow-lg
        ring-0 transition-transform
        data-checked:translate-x-4
        data-unchecked:translate-x-0
      "
    />
  </SwitchPrimitive.Root>
);
Switch.displayName = "Switch";

export { Switch };
